import React, { useState, useMemo } from 'react'
import styles from './Test.module.css'
import ModelQRCodePage_2 from '../../components/ModelsQRCodePage/components/ModelQRCodePage_2/ModelQRCodePage_2'
import { Slider } from 'antd'

const CANVAS_WIDTH = 1240
const CANVAS_HEIGHT = 1754

function Canvas({ zoom }) {
  const scale = useMemo(() => zoom / 100, [zoom])
  return (
    <div
      className={styles.example__canva}
      style={{
        width: `${CANVAS_WIDTH}px`,
        height: `${CANVAS_HEIGHT}px`,
        boxShadow: '0 2px 8px rgba(14,19,24,0.07)',
      }}
    >
      <h1>Salut moi c'est MARC</h1>
    </div>
  )
}

function Test() {
  const [zoom, setZoom] = useState(35)
  const scale = useMemo(() => zoom / 100, [zoom])

  return (
    <div className={styles.container}>
      <aside className={styles.sidebarLeft}>
        Sidebar
        <div className={styles.zoomControl}></div>
      </aside>

      <div className={styles.main}>
        <div className={styles.innerHeader}></div>
        <div className={styles.body}>
          <div className={styles.containerBody}>
            <div className={styles.contentBody}>
              <div className={styles.bodyContain}>
                <div className={styles.bodyItem}></div>
                <div className={styles.bodyCanvas}>
                  <div
                    className={styles.container__canvas}
                    style={{
                      width: `${CANVAS_WIDTH * scale}px`,
                      height: `${CANVAS_HEIGHT * scale}px`,
                    }}
                  >
                    <div
                      className={styles.zoom}
                      style={{
                        transform: `scale(${scale})`,
                      }}
                    >
                      <ModelQRCodePage_2 />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.innerFooter}>
          <Slider
            className={styles.slider}
            min={10}
            max={500}
            value={zoom}
            onChange={(value) => setZoom(value)}
          />
        </div>
      </div>
    </div>
  )
}

export default Test
